import { standardErrCheck } from "./base.services";
import { _redirectToLogin } from "./base.services";

const baseCfUrl = window._env_.VITE_BASE_CF_URL; // deployment

export const _selectPages = async (jobId: number, pageIds: number[], select: boolean, filter = '', pageOffset = ''): Promise<string> => {
    if (filter == '') {
        // If Check All with no filters, only check Pages with a status of 'Complete'
        filter = '/status/complete';
    }
    // If a single check, use no filter
    if (filter == 'single') filter = '';

    // Removes first "/" character from filter string
    filter = filter.substring(1);

    // If Server Side Pagination, adjust filter string
    if (pageOffset) {
        filter += `/?&offset=${pageOffset}`;
    }

    const resp = await fetch(`${baseCfUrl}/crawlfish/v1/jobs/${jobId}/select`, {
        'credentials': 'include',
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            select: select,
            ids: pageIds,
            filter: filter
        })
    });

    if (resp.status == 401) {
        _redirectToLogin();
    }

    await standardErrCheck(resp);
    const data = await resp.json();
    return data;
};

// Returns all the successful pages, with columns for: URL and Traffic Source, HardCoded
export const _generatePlineExportForSelectedPages = async (jobId: number, jobName: string) => {

    const resp = await fetch(`${baseCfUrl}/crawlfish/v1/export/${jobId}`, { 'credentials': 'include' });

    if (resp.status == 401) {
        _redirectToLogin();
    }

    await standardErrCheck(resp);

    resp.blob()
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `PL Export_${jobId}_${jobName}.csv`;
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();
            a.remove();  //afterwards we remove the element again 
        });
};


// Returns all the successful pages, AFTER applying filters
export const _generateQAExportByFilter = async (jobId: number, jobName: string, filterString = '') => {

    const resp = await fetch(`${baseCfUrl}/crawlfish/v1/csv/${jobId}?&q=status/complete${filterString}&limit=1000000`, { 'credentials': 'include' });

    if (resp.status == 401) {
        _redirectToLogin();
    }

    await standardErrCheck(resp);

    resp.blob()
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `QA Export_${jobId}_${jobName}.csv`;
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();
            a.remove();  //afterwards we remove the element again 
        });
};

// Job List page export, exports entire Job
export const _generateExportURLforJob = async (jobId: number, jobName: string) => {

    const resp = await fetch(`${baseCfUrl}/crawlfish/v1/csv/${jobId}?&q=status/complete&limit=1000000`, { 'credentials': 'include' });

    if (resp.status == 401) {
        _redirectToLogin();
    }

    await standardErrCheck(resp);

    resp.blob()
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${jobId}-${jobName}.csv`;
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();
            a.remove();  //afterwards we remove the element again 
        });
};

// Returns all the successful pages, with columns for: URL and Traffic Source, HardCoded
export const _generateSocialLinkExport = async (jobId: number, jobName: string) => {

    const resp = await fetch(`${baseCfUrl}/crawlfish/v1/jobs/${jobId}/social`, { 'credentials': 'include' });

    if (resp.status == 401) {
        _redirectToLogin();
    }

    await standardErrCheck(resp);

    resp.blob()
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `CF Social_Links_${jobId}_${jobName}.csv`;
            document.body.appendChild(a); // we need to append the element to the DOM -> otherwise it will not work in firefox
            a.click();
            a.remove();  //afterwards we remove the element again 
        });
};